import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./auth365Config";
// import * as Sentry from '@sentry/browser';
import App from './Containers/App'
import { registerServiceWorker } from './register-sw';
/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
 const msalInstance = new PublicClientApplication(msalConfig);

 export const { userAgent } = navigator

function render(Root) {
  if (userAgent.includes('Chrome/') || userAgent.includes('Firefox/') || userAgent.includes('Edg/')) {
    registerServiceWorker()
  }

    ReactDOM.render(
    <AppContainer>
      <MsalProvider instance={msalInstance}>
        <Root />
      </MsalProvider>
    </AppContainer>,
    document.getElementById('root'),
  )
}

render(App)

if (module.hot) {
  module.hot.accept('./Containers/App', () => {
    render(App)
  })
}



// WEBPACK FOOTER //
// ./src/index.jsx